import React, { Component } from 'react'
import { FaTrash } from 'react-icons/fa'

export default class CartItems extends Component {
    elem = this.props.elem;
    render() {
      return (
        <div className='cart__item item'>
          <img className='item__image' alt={this.elem.category} src={this.elem.img}/>
          <div className='item__box'>
            <h4 className='item__title'>{this.elem.title}</h4>
            <p className='item__price'><span>Сумма: </span>{this.elem.price}</p>
          </div>
          <FaTrash className='item__icon-trash' onClick={()=> this.props.onDelete(this.elem.id)}/>
        </div>
      )
    }
}
